import { render, staticRenderFns } from "./approvalFile.vue?vue&type=template&id=2911310c&scoped=true&"
import script from "./approvalFile.vue?vue&type=script&lang=js&"
export * from "./approvalFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2911310c",
  null
  
)

export default component.exports